import ReactHabitat from 'react-habitat';
import App from './components/App';
import './index.css';

class EmcoRebateCalc extends ReactHabitat.Bootstrapper {
    constructor(){
        super();

        // Create a new container builder:
        const builder = new ReactHabitat.ContainerBuilder();

        // Register a component:
        builder.register(App).as('EmcoRebateCalc');

        // Finally, set the container:
        this.setContainer(builder.build());
    }
}

// Always export a 'new' instance so it immediately evokes:
export default new EmcoRebateCalc();



// WEBPACK FOOTER //
// ./src/index.js